import { render, staticRenderFns } from "./TourWindow.vue?vue&type=template&id=167f9d1e&scoped=true&"
import script from "./TourWindow.vue?vue&type=script&lang=js&"
export * from "./TourWindow.vue?vue&type=script&lang=js&"
import style0 from "./TourWindow.vue?vue&type=style&index=0&id=167f9d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167f9d1e",
  null
  
)

export default component.exports